import type {ReactElement} from 'react';
import {ColorControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/color-control/color-control';
import {ICON_VECTOR_BG_FILL_PROP} from '@FormMakerReact/components/postermywall-icon-vector/postermywall-icon-vector';
import {DEFAULT_ICON_VECTOR_BG_COLOR} from '@FormMakerReact/layout/form-maker-right-panel/sectors/sectors.constants';
import type {IconVectorBgColorControlProps} from './icon-vector-bg-color-control.types';

export function IconVectorBgColorControl({component}: IconVectorBgColorControlProps): ReactElement {
  return (
    <ColorControl
      component={component}
      property={ICON_VECTOR_BG_FILL_PROP}
      labelKey="pmwjs_icon_background"
      pickAriaKey="pmwjs_icon_background"
      clearAriaKey="pmwjs_icon_background"
      defaultColor={DEFAULT_ICON_VECTOR_BG_COLOR}
      hideClearButton
    />
  );
}
